import React from 'react';
import {Navbar, Nav,NavDropdown} from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import rajon from '../../../images/rajon.png';
import ahmed from '../../../images/ahmed razon.png';
import ahmed2 from '../../../images/ezgif.com-gif-maker.gif';
import styles from './Menubar.module.css'

const Menubar = () => {
    let history = useHistory();
 
  
    return (
        <div >
            <nav className="navbar navbar-expand-lg navbar-light">
                <div className="container-fluid">
                   <Link to="/"> <img src={ahmed2} alt="mypic" className={styles.profile}/></Link> 
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNavDropdown">
                        <ul className="navbar-nav ms-auto">
                            <li className="nav-item">
                             <Link className="nav-link ms-4 textColor" to="/">Home</Link>
                            </li>
                            <li className="nav-item">
                            <Link className="nav-link textColor" to="/about">About</Link>
                            </li>
                            <li className="nav-item">
                            <Link className="nav-link textColor" to="/projects">Works</Link>
                            </li>
                            <li className="nav-item">
                            <Link className="nav-link textColor" to="/blog">Blog</Link>
                            </li>
                            <li className="nav-item">
                            <Link className="nav-link textColor" to="/contact">Contact</Link>       
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    );
};

export default Menubar;